export default function() {
    const self = this

    window.addEventListener('beforeunload', function (e) {
        if (self.sortingChanged) {
            e.preventDefault()
            e.returnValue = ''
        }
    });
}
